import paymentMethods from "./paymentMethods.component";
import paymentMethodsUrls from "./paymentMethods.urls";
import PaymentMethodsTransforms from "./paymentMethods.transforms";

const paymentMethodsModule = angular
  .module("app.components.paymentMethods", [])
  .component("paymentMethodsPage", paymentMethods)
  .service("PaymentMethodsTransforms", PaymentMethodsTransforms)
  .config(paymentMethodsUrls);

export default paymentMethodsModule;



// WEBPACK FOOTER //
// ./src/pages/paymentMethods/paymentMethods.module.js